import React from 'react';
import PropTypes from 'prop-types';

function FormSubmit({name, label, disabled}) {
    return (
        <div className='form__actions'>
            <div className='form__actionscontainer'>
                <button
                    className='form__submit button button--primary'
                    name={name || 'submit'}
                    type='submit'
                    disabled={disabled === true}
                >
                    <span className='button__label'>{label || name}</span>
                </button>
            </div>
        </div>
    );

}

FormSubmit.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

export default FormSubmit;

